export default __webpack_public_path__ + "static/media/unchecked.833e768a.svg";